import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function LatestInitiatives({ className }: IconProps) {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_684)">
        <path
          d="M38.0004 76C37.2418 76 36.6211 75.3793 36.6211 74.6207V1.37931C36.6211 0.62069 37.2418 0 38.0004 0C38.759 0 39.3797 0.62069 39.3797 1.37931V74.6207C39.3797 75.3793 38.759 76 38.0004 76Z"
          fill="#00C4B3"
        />
        <path
          d="M13.8165 75.9999C13.6326 75.9999 13.4487 75.9539 13.2648 75.885C12.5752 75.5861 12.2533 74.7585 12.5522 74.0689L36.7361 19.4252C37.0349 18.7356 37.8625 18.4137 38.5522 18.7126C39.2418 19.0344 39.5637 19.839 39.2648 20.5287L15.0809 75.1723C14.851 75.6781 14.3453 75.9999 13.8165 75.9999Z"
          fill="#00C4B3"
        />
        <path
          d="M62.1835 75.9999C61.6548 75.9999 61.149 75.701 60.9191 75.1723L36.7352 20.5286C36.4364 19.839 36.7352 19.0114 37.4479 18.7125C38.1375 18.4137 38.9651 18.7125 39.264 19.4252L63.4479 74.0459C63.7697 74.7355 63.4479 75.5631 62.7352 75.862C62.5513 75.9309 62.3674 75.9769 62.1835 75.9769"
          fill="#00C4B3"
        />
        <path
          d="M74.2533 8.6438H1.72461V60.4599H74.2533V8.6438Z"
          fill="#EAEDF8"
        />
        <path
          d="M54.644 29.7702L48.4141 26.6437C47.9544 26.4138 47.3797 26.5288 47.0578 26.9426L39.4716 36.207C39.1268 36.6207 38.5521 36.7357 38.0923 36.4828L32.8509 33.6552C32.4141 33.4253 31.8854 33.4943 31.5406 33.8621L24.3682 41.1265V54.8047H68.9429V18.3679C68.9429 17.7012 68.1383 17.3794 67.6785 17.8391L55.9544 29.5633C55.6095 29.9081 55.1038 29.9771 54.667 29.7702"
          fill="#00C4B3"
        />
        <path
          d="M75.3103 5.17236H0.689655C0.298851 5.17236 0 5.4942 0 5.86202V7.93098C0 8.32179 0.298851 8.62064 0.689655 8.62064H75.3103C75.7011 8.62064 76 8.2988 76 7.93098V5.86202C76 5.47121 75.6782 5.17236 75.3103 5.17236Z"
          fill="#00C4B3"
        />
        <path
          d="M75.3103 60.4597H0.689655C0.298851 60.4597 0 60.7816 0 61.1494V63.2183C0 63.6091 0.298851 63.908 0.689655 63.908H75.3103C75.7011 63.908 76 63.6091 76 63.2183V61.1494C76 60.7586 75.6782 60.4597 75.3103 60.4597Z"
          fill="#00C4B3"
        />
        <path
          d="M44.7585 55.2643V15.4942C44.7585 14.8735 43.9999 14.5746 43.5631 15.0114L35.4022 23.2873C35.1034 23.5861 34.6436 23.6781 34.2528 23.5172L29.1723 21.3103C28.7815 21.1493 28.3218 21.2183 28.0229 21.5401L21.3103 28.2988C20.9884 28.6436 20.4597 28.7126 20.0459 28.4597L15.7241 25.9539C15.3103 25.7011 14.7586 25.793 14.4367 26.1608L6.89648 34.6436V55.2643H44.7356H44.7585Z"
          fill="#EAEDF8"
        />
        <path
          d="M35.0803 37.816L29.2872 34.9194C28.8504 34.7125 28.3217 34.8275 28.0228 35.1953L20.9884 43.816C20.6665 44.2068 20.1378 44.2988 19.701 44.0689L14.8274 41.4482C14.4136 41.2183 13.9309 41.3102 13.609 41.6321L6.94238 48.3677V55.2873H48.3907V27.2183C48.3907 26.5976 47.655 26.2988 47.2182 26.7355L36.3217 37.6551C35.9999 37.9769 35.5171 38.0459 35.1263 37.839"
          fill="#00C4B3"
        />
        <path
          d="M23.8848 43.7701C23.8848 45.6781 22.3446 47.2183 20.4366 47.2183C18.5285 47.2183 16.9883 45.6781 16.9883 43.7701C16.9883 41.862 18.5285 40.3218 20.4366 40.3218C22.3446 40.3218 23.8848 41.862 23.8848 43.7701Z"
          fill="#FAFBFD"
        />
        <path
          d="M32.0001 21.0345C32.0001 22.9425 30.4598 24.4827 28.5518 24.4827C26.6437 24.4827 25.1035 22.9425 25.1035 21.0345C25.1035 19.1264 26.6437 17.5862 28.5518 17.5862C30.4598 17.5862 32.0001 19.1264 32.0001 21.0345Z"
          fill="#00416B"
        />
        <path
          d="M39.1954 37.4483C39.1954 39.3563 37.6551 40.8966 35.7471 40.8966C33.8391 40.8966 32.2988 39.3563 32.2988 37.4483C32.2988 35.5402 33.8391 34 35.7471 34C37.6551 34 39.1954 35.5402 39.1954 37.4483Z"
          fill="#FAFBFD"
        />
        <path
          d="M22.5061 43.7701C22.5061 44.9196 21.5866 45.8391 20.4371 45.8391C19.2877 45.8391 18.3682 44.9196 18.3682 43.7701C18.3682 42.6207 19.2877 41.7012 20.4371 41.7012C21.5866 41.7012 22.5061 42.6207 22.5061 43.7701Z"
          fill="#00416B"
        />
        <path
          d="M30.5979 21.0345C30.5979 22.184 29.6784 23.1035 28.5289 23.1035C27.3795 23.1035 26.46 22.184 26.46 21.0345C26.46 19.8851 27.4025 18.9656 28.5289 18.9656C29.6554 18.9656 30.5979 19.8851 30.5979 21.0345Z"
          fill="#00C4B3"
        />
        <path
          d="M37.8157 37.4484C37.8157 38.5978 36.8961 39.5173 35.7467 39.5173C34.5973 39.5173 33.6777 38.5978 33.6777 37.4484C33.6777 36.2989 34.5973 35.3794 35.7467 35.3794C36.8961 35.3794 37.8157 36.2989 37.8157 37.4484Z"
          fill="#00416B"
        />
        <path
          d="M21.1039 46.4597H19.7246V55.2643H21.1039V46.4597Z"
          fill="#FAFBFD"
        />
        <path
          d="M29.2182 23.7241H27.8389V55.2644H29.2182V23.7241Z"
          fill="#00416B"
        />
        <path
          d="M36.4369 40.1609H35.0576V55.2643H36.4369V40.1609Z"
          fill="#FAFBFD"
        />
        <path
          d="M8.98811 49.0575H6.91915C6.52834 49.0575 6.22949 48.7587 6.22949 48.3679C6.22949 47.9771 6.55133 47.6782 6.91915 47.6782H8.98811C9.37892 47.6782 9.67777 48.0001 9.67777 48.3679C9.67777 48.7357 9.35593 49.0575 8.98811 49.0575Z"
          fill="#00416B"
        />
        <path
          d="M8.98811 42.1379H6.91915C6.52834 42.1379 6.22949 41.839 6.22949 41.4482C6.22949 41.0574 6.55133 40.7585 6.91915 40.7585H8.98811C9.37892 40.7585 9.67777 41.0574 9.67777 41.4482C9.67777 41.839 9.35593 42.1379 8.98811 42.1379Z"
          fill="#00416B"
        />
        <path
          d="M8.98811 35.2414H6.91915C6.52834 35.2414 6.22949 34.9425 6.22949 34.5517C6.22949 34.1609 6.55133 33.8621 6.91915 33.8621H8.98811C9.37892 33.8621 9.67777 34.1839 9.67777 34.5517C9.67777 34.9195 9.35593 35.2414 8.98811 35.2414Z"
          fill="#00416B"
        />
        <path
          d="M8.98811 28.3219H6.91915C6.52834 28.3219 6.22949 28.0231 6.22949 27.6323C6.22949 27.2415 6.55133 26.9426 6.91915 26.9426H8.98811C9.37892 26.9426 9.67777 27.2645 9.67777 27.6323C9.67777 28.0001 9.35593 28.3219 8.98811 28.3219Z"
          fill="#00416B"
        />
        <path
          d="M8.98811 21.4252H6.91915C6.52834 21.4252 6.22949 21.1264 6.22949 20.7356C6.22949 20.3447 6.55133 20.0459 6.91915 20.0459H8.98811C9.37892 20.0459 9.67777 20.3447 9.67777 20.7356C9.67777 21.1264 9.35593 21.4252 8.98811 21.4252Z"
          fill="#00416B"
        />
        <path
          d="M8.98811 14.5058H6.91915C6.52834 14.5058 6.22949 14.2069 6.22949 13.8161C6.22949 13.4253 6.55133 13.1265 6.91915 13.1265H8.98811C9.37892 13.1265 9.67777 13.4483 9.67777 13.8161C9.67777 14.1839 9.35593 14.5058 8.98811 14.5058Z"
          fill="#00416B"
        />
        <path
          d="M58.3907 29.9771C58.3907 31.8851 56.8505 33.4254 54.9424 33.4254C53.0344 33.4254 51.4941 31.8851 51.4941 29.9771C51.4941 28.069 53.0344 26.5288 54.9424 26.5288C56.8505 26.5288 58.3907 28.069 58.3907 29.9771Z"
          fill="#FAFBFD"
        />
        <path
          d="M51.379 20.8965C51.379 22.8046 49.8387 24.3448 47.9307 24.3448C46.0227 24.3448 44.4824 22.8046 44.4824 20.8965C44.4824 18.9885 46.0227 17.4482 47.9307 17.4482C49.8387 17.4482 51.379 18.9885 51.379 20.8965Z"
          fill="#00416B"
        />
        <path
          d="M72.1378 17.9309C72.1378 19.839 70.5975 21.3792 68.6895 21.3792C66.7814 21.3792 65.2412 19.839 65.2412 17.9309C65.2412 16.0229 66.7814 14.4827 68.6895 14.4827C70.5975 14.4827 72.1378 16.0229 72.1378 17.9309Z"
          fill="#FAFBFD"
        />
        <path
          d="M57.012 29.9769C57.012 31.1263 56.0924 32.0459 54.943 32.0459C53.7936 32.0459 52.874 31.1263 52.874 29.9769C52.874 28.8275 53.7936 27.908 54.943 27.908C56.0924 27.908 57.012 28.8275 57.012 29.9769Z"
          fill="#00416B"
        />
        <path
          d="M50.0002 20.8966C50.0002 22.046 49.0807 22.9656 47.9313 22.9656C46.7818 22.9656 45.8623 22.046 45.8623 20.8966C45.8623 19.7472 46.8048 18.8276 47.9313 18.8276C49.0577 18.8276 50.0002 19.7472 50.0002 20.8966Z"
          fill="#00C4B3"
        />
        <path
          d="M70.759 17.931C70.759 19.0805 69.8395 20 68.6901 20C67.5406 20 66.6211 19.0805 66.6211 17.931C66.6211 16.7816 67.5406 15.8621 68.6901 15.8621C69.8395 15.8621 70.759 16.7816 70.759 17.931Z"
          fill="#00416B"
        />
        <path
          d="M55.6322 32.6667H54.2529V54.6667H55.6322V32.6667Z"
          fill="#FAFBFD"
        />
        <path
          d="M48.6205 23.6091H47.2412V55.1494H48.6205V23.6091Z"
          fill="#00416B"
        />
        <path
          d="M69.3559 20.6436H67.9766V54.5516H69.3559V20.6436Z"
          fill="#FAFBFD"
        />
        <path
          d="M70.2755 55.9541H6.91915C6.52834 55.9541 6.22949 55.6552 6.22949 55.2644V13.8161C6.22949 13.4253 6.55133 13.1265 6.91915 13.1265C7.28696 13.1265 7.6088 13.4253 7.6088 13.8161V54.5747H70.2985C70.6893 54.5747 70.9881 54.8736 70.9881 55.2644C70.9881 55.6552 70.6663 55.9541 70.2985 55.9541"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_684">
          <rect width="76" height="76" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
